import React from 'react';
import { ApplicationStatuses } from '../../../lib/systemVariables';

export default class ApplicationStatusTag extends React.Component {
    render() {
        switch (this.props.status) {
            case ApplicationStatuses.Paid:
                return <span className="tag blue">{ApplicationStatuses.Paid}</span>;
            case ApplicationStatuses.Rejected:
                return <span className="tag red">{ApplicationStatuses.Rejected}</span>;
            case ApplicationStatuses.Incomplete:
                return <span className="tag gray">{ApplicationStatuses.Incomplete}</span>;
            case ApplicationStatuses.Approved:
                return <span className="tag green">{ApplicationStatuses.Approved}</span>;
            case ApplicationStatuses.InReview:
                return <span className="tag purple">{ApplicationStatuses.InReview}</span>;
            case ApplicationStatuses.New:
                return <span className="tag yellow">{ApplicationStatuses.New}</span>;
            default:
                return <span />;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/ApplicationStatusTag.jsx